import type { PeriodicCampaignDto } from "../../types/PeriodicCampaignDto";
import type { PeriodicCampaignEntity } from "../../types/PeriodicCampaignEntity";

export const PeriodicCampaignEntityToDto = ({ ...rest }: Readonly<PeriodicCampaignEntity>): PeriodicCampaignDto => {
    return { ...rest };
};
